import React, { ReactNode } from 'react'
import styles from './styles/info-box.module.scss'
import { Info } from 'components/Icons'
import { ReactComponent as Alert } from 'images/icons/icn_alert.svg'
import classNames from 'classnames'

interface Props {
  children: ReactNode
  className?: string
  classIcon?: string
  classContent?: string
  iconColor?: 'red' | 'blue'
  iconType?: 'info' | 'alert'
  boxColor?: 'red' | 'blue' | 'yellow' | 'transparent'
  textOnly?: boolean
  hasShadow?: boolean
}

const iconStyles = {
  blue: styles.iconBlue,
  red: styles.iconRed,
}

const boxStyles = {
  blue: styles.boxBlue,
  red: styles.boxRed,
  yellow: styles.boxYellow,
  transparent: styles.boxTransparent,
}

const InfoBox = ({
  children,
  textOnly,
  className = '',
  classIcon = '',
  classContent = '',
  iconColor = 'blue',
  boxColor = 'blue',
  hasShadow = true,
  iconType = 'info',
}: Props) => {
  const Icon = iconType === 'info' ? Info : Alert
  return (
    <div
      className={classNames(styles.box, boxStyles[boxColor], className, {
        [styles.boxShadow]: hasShadow,
      })}
      role='alert'
    >
      {!textOnly && (
        <div className={classNames(iconStyles[iconColor], classIcon)} aria-hidden>
          <Icon />
        </div>
      )}

      <div className={classNames(styles.content, classContent)}>{children}</div>
    </div>
  )
}

export default InfoBox
